import { createAction, props } from '@ngrx/store';

const ACTION_KEY = '[Inbox filter]';

export const setStatus = createAction(
  `${ACTION_KEY} set status`,
  props<{ status: 'active' | 'expired' }>(),
);

export const loadFavorite = createAction(
  `${ACTION_KEY} load favorite`,
  props<{ loadFavorite: boolean }>(),
);
